import BaoDialogViewModel from "../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";

/** 
 * Dialog for choosing a Shiftbook 
 */
class ShiftbookSelectorDialog {
    constructor(dialog: BaoDialogViewModel) {
        this.Dialog = dialog;
    }
    Bao = Bao;
    Dialog = null;
    Items = ko.observableArray();
    SelectedItem = ko.observable();
    SelectItem(item) {
        if (this.Dialog != null && this.Dialog.Close != null) {
            this.SelectedItem(item);
            this.Dialog.DialogResult(true);
            this.Dialog.Close();
        }
    }
}
export default ShiftbookSelectorDialog;